export default __webpack_public_path__ + "static/media/vaddy.d347be3d.svg";